module.exports = __webpack_public_path__ + "static/media/font_regular.69b86704.woff";